




import Vue from 'vue';

export default Vue.extend({
  props: {
    inactivityDuration: {
      type: Number,
      default: 60000,
    },
  },
  data() {
    return {
      inactivityTimer: null as ReturnType<typeof setTimeout> | null,
    };
  },
  mounted() {
    this.setupInactivityListeners();
    this.resetInactivityTimer();
  },
  beforeDestroy() {
    this.removeInactivityListeners();
    clearTimeout(this.inactivityTimer as ReturnType<typeof setTimeout>);
  },
  methods: {
    resetInactivityTimer() {
      clearTimeout(this.inactivityTimer as ReturnType<typeof setTimeout>);
      this.inactivityTimer = setTimeout(this.handleInactivity, this.inactivityDuration);
    },
    handleInactivity() {
      this.$emit('inactivity');
    },
    setupInactivityListeners() {
      window.addEventListener('load', this.resetInactivityTimer);
      window.addEventListener('mousemove', this.resetInactivityTimer);
      window.addEventListener('keypress', this.resetInactivityTimer);
      window.addEventListener('touchstart', this.resetInactivityTimer);
      window.addEventListener('click', this.resetInactivityTimer);
      window.addEventListener('keydown', this.resetInactivityTimer);
    },
    removeInactivityListeners() {
      window.removeEventListener('load', this.resetInactivityTimer);
      window.removeEventListener('mousemove', this.resetInactivityTimer);
      window.removeEventListener('keypress', this.resetInactivityTimer);
      window.removeEventListener('touchstart', this.resetInactivityTimer);
      window.removeEventListener('click', this.resetInactivityTimer);
      window.removeEventListener('keydown', this.resetInactivityTimer);
    },
  },
});
